import React from "react";
import { Form, Modal } from "antd";
import api from '../../api/api/index';
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { tokenAction } from "../../redux-stuffs/actions/token_action";
import PhoneInput from 'react-phone-input-2';
import { profileAction } from "../../redux-stuffs/actions/profile_action";
import queryString from "query-string";
import withRecoil from "../../withRecoil";
import { accessTokenState, phoneState, nameState, emailState } from "../../atoms";
import { withTranslation } from 'react-i18next';

function error(title, content) {
    Modal.error({ title, content });
}

class SignupComponent extends React.Component {
    handleFormSubmit = (e) => {
        e.preventDefault();
        const { t } = this.props;

        this.props.form.validateFields((err, values) => {
            if (!err) {
                const finalBody = {
                    password: values.password,
                    device_type: -1,
                    device_token: 0,
                    app_version: 0,
                    name: values.name,
                    date_of_birth: Date.now(),
                    source: "Web Portal",
                    email: values.email,
                    phone: values.phone.replace(/[- )(]/g, ''),
                };

                fetch(`${api.main}/phone_signup`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                    body: queryString.stringify(finalBody)
                })
                    .then(response => {
                        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                        return response.json();
                    })
                    .then(res => {
                        if (res.status !== 105) {
                            error(t('common:error'), res.message);
                        } else {
                            this.props.recoilStates[accessTokenState.key].setState(res.data.access_token);
                            this.props.recoilStates[phoneState.key].setState(res.data.phone);
                            this.props.recoilStates[emailState.key].setState(res.data.email);
                            this.props.recoilStates[nameState.key].setState(res.data.name);

                            this.props.tokenAction(res.data.access_token)
                                .then(_ => this.props.profileAction(res.data))
                                .then(_ => {
                                    this.props.history.push({ pathname: '/signup-flow' });
                                });
                        }
                    })
                    .catch(err => {
                        error(t('common:error'), err.message);
                    });
            } else {
                error(t('common:error'), String(err));
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { t } = this.props;

        return (
            <div className="container mt-4">
                <div className="spare-dvs vh-100 align-items-start">
                    <div className="w-100 float-left">
                        <div style={{ padding: '30px' }}>
                            <img
                                src={process.env.PUBLIC_URL + "/images/spare_logo_full.png"}
                                alt="Spare Logo"
                                className="responsive-image"
                                style={{ maxWidth: '30%' }}
                            />
                        </div>

                        <h1>{t('signup:title')}</h1>

                        <div className="email-dvs">
                            <Form onSubmit={this.handleFormSubmit}>
                                {/* Phone */}
                                <Form.Item>
                                    {getFieldDecorator('phone', {
                                        rules: [
                                            { required: true, message: t('signup:phoneRequired') },
                                            {
                                                validator: (rule, value = '', callback) => {
                                                    const v = value.replace(/[- +)(]/g, '');
                                                    if (v.length < 8) callback(t('signup:phoneInvalid'));
                                                    else callback();
                                                }
                                            }
                                        ],
                                    })(
                                        <PhoneInput
                                            country={'us'}
                                            style={{ width: "100%", marginBottom: "10px", marginTop: "20px" }}
                                        />
                                    )}
                                </Form.Item>

                                {/* Name */}
                                <Form.Item>
                                    {getFieldDecorator('name', {
                                        rules: [{ required: true, message: t('signup:nameRequired') }],
                                    })(
                                        <p><input type="text" placeholder={t('signup:namePlaceholder')} /></p>
                                    )}
                                </Form.Item>

                                {/* Email */}
                                <Form.Item>
                                    {getFieldDecorator('email', {
                                        rules: [{ required: true, message: t('signup:emailRequired') }],
                                    })(
                                        <p><input type="email" placeholder={t('signup:emailPlaceholder')} /></p>
                                    )}
                                </Form.Item>

                                {/* Password */}
                                <Form.Item>
                                    {getFieldDecorator('password', {
                                        rules: [
                                            { required: true, message: t('signup:passwordRequired') },
                                            {
                                                validator: (rule, value = '', callback) => {
                                                    if (value.length >= 8) callback();
                                                    else callback(t('signup:passwordMin'));
                                                }
                                            }
                                        ],
                                    })(
                                        <p><input type="password" placeholder={t('signup:passwordPlaceholder')} /></p>
                                    )}
                                </Form.Item>

                                {/* Confirm Password */}
                                <Form.Item>
                                    {getFieldDecorator('confirmPassword', {
                                        rules: [
                                            { required: true, message: t('signup:confirmRequired') },
                                            {
                                                validator: (rule, value, callback) => {
                                                    if (value === this.props.form.getFieldValue('password')) callback();
                                                    else callback(t('signup:passwordMismatch'));
                                                }
                                            }
                                        ],
                                    })(
                                        <p><input type="password" placeholder={t('signup:confirmPlaceholder')} /></p>
                                    )}
                                </Form.Item>

                                {/* Terms */}
                                <Form.Item>
                                    {getFieldDecorator('termsAndConditions', {
                                        rules: [
                                            { required: true, message: ' ' },
                                            {
                                                validator: (rule, value, callback) => {
                                                    if (value) callback();
                                                    else callback(t('signup:acceptTerms'));
                                                }
                                            }
                                        ],
                                    })(
                                        <div style={{ paddingTop: 10 }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flexWrap: 'nowrap',
                                                    whiteSpace: 'nowrap',
                                                    gap: 8,            // space between items
                                                }}
                                            >
                                                <input
                                                    id="acceptTerms"
                                                    type="checkbox"
                                                    style={{ flex: '0 0 auto' }}
                                                />

                                                <label
                                                    htmlFor="acceptTerms"
                                                    style={{ margin: 0, display: 'inline-flex', alignItems: 'center', gap: 4 }}
                                                >
                                                    {t('signup:acceptPrefix')}&nbsp;
                                                    <a
                                                        target="_blank"
                                                        href="https://docs.google.com/document/d/1Kg7xb8oWzwVyqpV9rxF17rLdrJzJFMHaIZBfcRX7kRc/edit"
                                                        rel="noopener noreferrer"
                                                        className="sign-anchr"
                                                        style={{ whiteSpace: 'nowrap' }}
                                                    >
                                                        {t('signup:termsLink')}
                                                    </a>
                                                </label>
                                            </div>
                                        </div>

                                    )}
                                </Form.Item>

                                {/* Submit */}
                                <button className="action-button btn" type="submit" name="" onClick={this.handleFormSubmit}>{t('signup:submit')}</button>

                                {/* Already have account */}
                                <div className="alrdy-acnt">
                                    <span>
                                        {t('signup:alreadyHave')}{' '}
                                        <a href="/login" className="sign-anchr">{t('signup:loginLink')}</a>
                                    </span>
                                </div>
                            </Form>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const Base = withTranslation(['signup', 'common'])(SignupComponent);
const WrappedHorizontalSignUpForm = Form.create({ name: 'signup_form' })(Base);

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            tokenAction,
            profileAction
        },
        dispatch,
    );

const mapStateToProps = state => ({ token: state.token });

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withRecoil(WrappedHorizontalSignUpForm, [accessTokenState, phoneState, nameState, emailState])));
